import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';

import { GetPastConferencesDataType } from '@/api/conference';
import { Forum, Gallery, Newsletter, Notice, Trend } from '@/api/notice';
import LineIcon from '@/components/Icon/lineIcon';
import { normalizeInformationMenu } from '@/constants/information';

import * as S from './style';

interface ConferenceListProps {
	data: (Gallery | Notice | Forum | Newsletter | Trend | GetPastConferencesDataType)[];
	sort: string;
}

const PostList = ({ data, sort }: ConferenceListProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const params = normalizeInformationMenu(location.state?.menu);
	const getDynamicField = (g: any, field: string) => g[`${sort}_${field}`] || ''; // 동적으로 필드 처리
	const handleGetPk = (pk: number | string) => {
		if (sort === 'guide') {
			navigate(`/conference/detail/${pk}`, { state: { menu: params } });
			return;
		} else if (sort === 'notice') {
			navigate(`/information/notice/${pk}`, { state: { menu: params } });
			return;
		} else if (sort === 'forum') {
			navigate(`/information/community/${pk}`, { state: { menu: params } });
			return;
		}
	};
	return (
		<S.PostList>
			{data.map((item) => (
				<S.PostListItem key={getDynamicField(item, 'pk')} onClick={() => handleGetPk(getDynamicField(item, 'pk'))}>
					<div className="title">{getDynamicField(item, 'title')}</div>
					<div className="sub_title">
						{getDynamicField(item, 'enrollment_date') === '' ? '-' : dayjs(getDynamicField(item, 'enrollment_date')).format('YYYY-MM-DD')}
						<LineIcon />
						{t('information.detail.views')}: {getDynamicField(item, 'hit') === '' ? '0' : getDynamicField(item, 'hit')}
					</div>
				</S.PostListItem>
			))}
		</S.PostList>
	);
};

export default PostList;
